import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MdbTableDirective, MdbTablePaginationComponent, ModalDirective } from 'angular-bootstrap-md';

import { AlertService } from 'ngx-alerts';
import { ClienteService } from '../cliente.service';
import { CuentasxcobrarService } from '../cuentasxcobrar.service';
import { cxcRetencion } from '../cxcRetencion';
import { RetencionVentasService } from '../retencion-ventas.service';

@Component({
  selector: 'app-retencion-ventas',
  templateUrl: './retencion-ventas.component.html',
  styleUrls: ['./retencion-ventas.component.css']
})
export class RetencionVentasComponent implements OnInit {


  listaRenetenciones: cxcRetencion[] = [];
  listaRenetencionesActulizar: cxcRetencion[] = [];
  cxcRetencion: cxcRetencion;
  entidadCxC: cxcRetencion = new cxcRetencion();
  searchText: string = '';
  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;
  @ViewChild('processingModal') public mdbModal: ModalDirective;
  @ViewChild('modalRetencion') public mdbModalRetencion: ModalDirective;
  isLoadingResults = true;
  previous: any = [];
  porcentajeIva:number;
  porcentajeFuente:number;

  constructor(private  retencionVentas:RetencionVentasService,  private apiClien: ClienteService, private ruter: Router, private alertService: AlertService, private api: CuentasxcobrarService, private cdRef: ChangeDetectorRef, private formBuilder: FormBuilder) { }

  @HostListener('input') oninput() {
    this.searchItems();
  }


  

  valueIvaChange(valor:number){
    this.cxcRetencion.porcentaje_iva=valor;
    this.cxcRetencion.valor_iva=this.cxcRetencion.iva_factura-((valor/100)*this.cxcRetencion.iva_factura)
  }

  valueFuenteChange(valor:number){
    this.cxcRetencion.porcentaje_renta=valor;
    this.cxcRetencion.valor_renta=this.cxcRetencion.sub_total_factura-((valor/100)*this.cxcRetencion.sub_total_factura);
  }

  retencion(entidad:cxcRetencion) {
    this.porcentajeIva=this.cxcRetencion.porcentaje_iva;
    this.porcentajeFuente=this.cxcRetencion.porcentaje_renta;
    this.cxcRetencion = entidad;
   this.mdbModal.show();
  }

  actualizar() {
    this.listaRenetencionesActulizar= [];
    this.cxcRetencion.estado='INGRESADO';
    this.listaRenetencionesActulizar.push(this.cxcRetencion);
    this.retencionVentas.setActulizar(this.listaRenetencionesActulizar).subscribe(

      data => {
        this.mdbModal.hide();
        this.alertService.info("Se Guardo con exito...")
        this.listarCXC();
      },

      error => {

        this.alertService.danger(error)

      });

  }
  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.listaRenetenciones = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.listaRenetenciones = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }
  
  ngOnInit(): void {
  this.listarCXC();
  this.cxcRetencion= new cxcRetencion();
  }

  listarCXC() {

    this.retencionVentas.getListaRetencionVenta(localStorage.getItem('id'))
      .subscribe((
        data: cxcRetencion[]) => {
        this.listaRenetenciones = data;
        this.mdbTable.setDataSource(this.listaRenetenciones);
        this.mdbTable.dataSourceChange();
        this.previous = this.mdbTable.getDataSource();
     
       }
        , err => {
          console.log(err);
          this.isLoadingResults = false;
        });
  }




}
